import { render, staticRenderFns } from "./franchiseesroleslist.vue?vue&type=template&id=64f80f48&scoped=true"
import script from "./franchiseesroleslist.vue?vue&type=script&lang=js"
export * from "./franchiseesroleslist.vue?vue&type=script&lang=js"
import style0 from "./franchiseesroleslist.vue?vue&type=style&index=0&id=64f80f48&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f80f48",
  null
  
)

export default component.exports